module.exports = __webpack_public_path__ + "static/banner_hero-image3-9b174ad4d65a8c83b36f70f9543aa38f.png";